import { render, staticRenderFns } from "./AssessmentReportDDS.vue?vue&type=template&id=fa714b52&scoped=true"
import script from "./AssessmentReportDDS.vue?vue&type=script&lang=js"
export * from "./AssessmentReportDDS.vue?vue&type=script&lang=js"
import style0 from "./AssessmentReportDDS.vue?vue&type=style&index=0&id=fa714b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa714b52",
  null
  
)

export default component.exports